import React from "react";
import { YoutubeVideoInterface } from "../../../../store/mine_craft/youtubeVideosSlice";

import { Button, Form, Input, Switch } from "antd";
import { TagFilled, TagOutlined } from "@ant-design/icons";
import FileDropzone from "../../../../componets/FileDropzone";

interface propsInterface {
  params?: YoutubeVideoInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <Form.Item name='app_id' noStyle>
        <Input type="hidden" />
      </Form.Item>

      <div className='v-group-dropzone'>
        <FileDropzone name='thumbnail' label='Thumbnail' preview={params?.thumbnail_url} />
      </div>

      <Form.Item name='title' label="Title">
        <Input placeholder='Title' />
      </Form.Item>

      <Form.Item name='url' label="Url">
        <Input placeholder='https://youtube.com/video_id' />
      </Form.Item>

      <Form.Item label="New" name='is_new' valuePropName='checked'>
        <Switch
          checkedChildren={<TagOutlined />}
          unCheckedChildren={<TagFilled />}
        />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
